<template>
	<div class="background">
		<div class="container">
			<div
				class="row justify-content-lg-center justify-content-md-center">
				<div class="col-lg-12">
					<div class="main_logo" id="logo">
						<img
							src="../../../public/admin/images/logo.svg"
							alt="logo da empresa" />
					</div>
				</div>
			</div>
			<div class="row justify-content-center">
				<div class="col-12">
					<div class="card card-shadow p-5">
						<slot />
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="text-center">
		<p>
			© {{ new Date().getFullYear() }} <strong>Habilite-se</strong>.
			Todos os direitos reservados.
		</p>
	</div>
</template>

<script lang="ts">
	import Layout from '../Layouts/empty_layout.vue';

	export default {
		layout: Layout,
	};
</script>

<style scoped>
	.main_logo {
		float: none;
		width: 255px;
		text-align: center;
		margin: auto !important;
		padding: 50px 0;
	}

	.background {
		background: #f7f7f7 !important;
		width: 100%;
		height: 100%;
	}

	.background:before {
		content: '';
		background: url(../../../public/admin/images/sign.svg) no-repeat center;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		position: absolute;
		pointer-events: none;
		background-size: cover;
		opacity: 0.04;
	}
</style>
